export const APP_URL = process.env.VUE_APP_APP_URL

export const IDENTITY_SERVER_URL = process.env.VUE_APP_IDENTITY_SERVER_URL
export const IDENTITY_CLIENTID = process.env.VUE_APP_IDENTITY_CLIENTID

export const API_NAME = process.env.VUE_APP_API_NAME
export const API_URL = process.env.VUE_APP_API_URL
export const THEME = process.env.VUE_APP_THEME
